<template>
  <!-- Position defined in parent component (must be absolute or relative) -->
  <div class="fade-overlay flex items-center justify-center pointer-events-none">
    <div class="info-card flex flex-col gap-4 items-center pointer-events-auto">
      <div class="flex flex-col items-center py-1 text-center">
        <LockedIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted mt-4 px-6">
          {{ title }}
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal mt-2 px-14">
          {{ description }}
        </BaseText>
      </div>
      <BasePrimaryButton 
        class="pointer-events-auto"
        text="Start Tracking"
        @click="trackBrand"
      />
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/BaseNotifications/EventBus'
import LockedIcon from '@/components/globals/Icons/LockedIconV2.vue'

export default {
  name: 'AdsLockedOverlay',
  components: {
    LockedIcon
  },
  props: {
    title: {
      type: String,
      default: 'Ads Locked'
    },
    description: {
      type: String,
      default: 'This brand is locked. Please upgrade to view the full data.'
    }
  },
  methods: {
    trackBrand () {
      EventBus.$emit('spyder:track-brand')
    }
  }
}
</script>

<style scoped>
.fade-overlay {
  background: linear-gradient(to top, white 0%, white 202px, transparent 100%);
}
.info-card {
  position: absolute;
  left: 50%;
  bottom: 72px;
  max-width: 488px;
  transform: translateX(-50%);
  border: 1px solid #EAEFF3;
  box-shadow: 0 6px 12px -3px rgba(24, 35, 68, 0.04), 0 2px 4px -1.5px rgba(24, 35, 68, 0.04), 0 1px 2px -0.75px rgba(24, 35, 68, 0.04);
  border-radius: 16px;
  padding: 12px;
  background-color: white;
}
</style>